<script>
import { mapState, mapActions } from 'vuex';
import TableFilterRadioGroup from '../../components/payments/supplier-payments/SupplierPaymentsTableFilterRadioGroup';
import DateFilters from '../../components/payments/PaymentsDateFilters';
import MainFilters from '../../components/payments/supplier-payments/SupplierPaymentsMainFilters';
import TableContainer from '../../components/payments/supplier-payments/SupplierPaymentsTableContainer';

export default {
  name: 'SupplierPayments',
  components: {
    TableFilterRadioGroup,
    DateFilters,
    MainFilters,
    TableContainer,
  },
  computed: {
    ...mapState({
      arrivalFromDate: state => state.supplierPayments.filter.date.arrivalFromDate,
      arrivalToDate: state => state.supplierPayments.filter.date.arrivalToDate,
      paidDateFromDate: state => state.supplierPayments.filter.date.paidDateFromDate,
      paidDateToDate: state => state.supplierPayments.filter.date.paidDateToDate,
      filterLoading: state => state.supplierPayments.filter.data.loading,
      filterError: state => state.supplierPayments.filter.data.error,
      loading: state => state.supplierPayments.tableData.loading,
      error: state => state.supplierPayments.tableData.error,
      type: state => state.supplierPayments.filter.data.selectedTableType,
    }),
    disabled() {
      return this.filterLoading || this.filterError || this.loading;
    },
  },
  methods: {
    ...mapActions({
      loadFilters: 'supplierPayments/getFilterData',
      loadTableData: 'supplierPayments/loadTableData',
      updateFilterArrivalFromDate: 'supplierPayments/updateFilterArrivalFromDate',
      updateFilterArrivalToDate: 'supplierPayments/updateFilterArrivalToDate',
      updateFilterPaidDateFromDate: 'supplierPayments/updateFilterPaidDateFromDate',
      updateFilterPaidDateToDate: 'supplierPayments/updateFilterPaidDateToDate',
      setBreadcrumbs: 'nav/setBreadcrumbs',
      clearState: 'supplierPayments/clearState',
    }),
    getTableData() {
      if (this.filterLoading || this.loading) {
        return;
      }
      this.loadTableData(this.type);
    },
  },
  created() {
    this.loadFilters();
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: this.$t('pages.payments'), to: '', disabled: true },
        { text: this.$t('pages.supplierPayments'), to: this.$route.path },
      ],
      title: this.$t('pages.supplierPayments'),
    });
  },
  beforeRouteLeave(to, from, next) {
    this.clearState();
    next();
  },
};
</script>

<template>
  <v-flex>
    <v-flex v-if="filterLoading || filterError">
      <v-progress-linear v-if="filterLoading" class="ma-0 pa-0" indeterminate/>
      <v-alert :value="filterError" type="error">
        {{ $t('payments.filters.error') }}
      </v-alert>
    </v-flex>
    <v-container fluid>
      <v-layout row>
        <v-flex xs6>
          <table-filter-radio-group/>
        </v-flex>
        <v-flex xs6>
          <date-filters
            @updateFilterArrivalFromDate="updateFilterArrivalFromDate"
            @updateFilterArrivalToDate="updateFilterArrivalToDate"
            @updateFilterPaidDateFromDate="updateFilterPaidDateFromDate"
            @updateFilterPaidDateToDate="updateFilterPaidDateToDate"
            :arrival-from-date="arrivalFromDate"
            :arrival-to-date="arrivalToDate"
            :paid-date-from-date="paidDateFromDate"
            :paid-date-to-date="paidDateToDate"
            :disabled="disabled"
          />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <main-filters/>
        </v-flex>
      </v-layout>
      <v-layout row mt-4>
        <v-btn
          @click="getTableData"
          :disabled="disabled"
          color="primary darken-1"
          block
        >
          {{ $t('inputs.search') }}
        </v-btn>
      </v-layout>
      <v-layout row v-if="!filterLoading && !filterError">
        <table-container @refresh="getTableData"/>
      </v-layout>
    </v-container>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/pages/Payments/SupplierPayments.vue